// src/features/users/components/UserManagement/index.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { fetchUsers, fetchDepartments } from '../../../../api';
import { useAuth }    from '../../../auth/context/AuthContext';
import LoadingSpinner from '../../../../shared/components/ui/LoadingSpinner';
import UserFormCard   from './UserFormCard';
import UserListCard   from './UserListCard';
import styles         from './UserManagement.module.css';

const NON_CLIENT_ROLES = ['admin', 'dept_manager', 'employee'];

const UserManagement = () => {
  const { canAccess }                 = useAuth();
  const [users,       setUsers]       = useState([]);
  const [departments, setDepartments] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [error,       setError]       = useState('');

  const loadData = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const [ur, dr] = await Promise.all([fetchUsers(), fetchDepartments()]);
      setUsers(
        ur.data.filter(u =>
          NON_CLIENT_ROLES.includes(u.role_key) ||
          NON_CLIENT_ROLES.includes(u.role)     ||
          (u.role !== 'زبون' && u.role_key !== 'client')
        )
      );
      setDepartments(dr.data);
    } catch {
      setError('فشل في جلب البيانات.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadData(); }, [loadData]);

  const handleEditClick  = (user) => setEditingUser(user);
  const handleCancelEdit = ()     => setEditingUser(null);

  const handleSaveSuccess = () => {
    setEditingUser(null);
    loadData();
  };

  if (loading) return <LoadingSpinner message="جاري تحميل المستخدمين..." />;

  return (
    <div className={styles.container}>

      {error && (
        <p style={{
          color:        'var(--color-danger-text)',
          background:   'var(--color-danger-subtle)',
          border:       '1px solid var(--color-danger-muted)',
          borderRight:  '4px solid var(--color-danger)',
          padding:      'var(--space-4)',
          borderRadius: 'var(--radius-md)',
          fontWeight:   'var(--font-semibold)',
          marginBottom: 'var(--space-4)',
        }}>
          {error}
        </p>
      )}

      <div className={styles.grid}>

        {canAccess('users') && (
          <UserFormCard
            editingUser={editingUser}
            departments={departments}
            onSaveSuccess={handleSaveSuccess}
            onCancelEdit={handleCancelEdit}
          />
        )}

        <UserListCard
          users={users}
          loading={false}
          onEditClick={handleEditClick}
        />

      </div>
    </div>
  );
};

export default UserManagement;